export default function() {
  const widgetName = 'cardWidgetEmailSignup';
  const widgetOpts = cardWidgetEmailSignupOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const button = $(`#${widgetName} a`);
      button.addClass('button');
      button.attr('href', 'javascript:void(0);');
      button.html(data.items[0].DetailLinkText);
      button.on('keypress click', function(event) {
        event.preventDefault();
        if (event.key === 'Enter' || event.type === 'click') {
          $('.emailSignup .emailSubmitButton').click();
        }
      });

    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'Click to Subscribe'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: false,
      margin: 10,
      navText: ['Prev','Next'],
      nav: false
    },
    textOverImage: false
  });

}